export function getLocalStore(name, decode = false, boolean = false)
{
    const store = localStorage.getItem(name)
    if(decode){
        return JSON.stringify(store)
    }
    if(boolean){
        return store === "true" ? true : false
    }
    return store;
}

export function setLocalStore(name, data, encode = false)
{
    localStorage.setItem(
        name, (encode ? JSON.stringify(data) : data)
    )
}

export function deleteLocalStore(name)
{
    localStorage.removeItem(name)
}

export function purgeLocalStore()
{
    localStorage.clear()
}

export function getJsonLocalStore(name, fallback = null)
{
    if (typeof localStorage === 'undefined') return fallback;

    try {
        const value = localStorage.getItem(name);
        return value === null ? fallback : JSON.parse(value);
    } catch (error) {
        return fallback;
    }
}

export function setJsonLocalStore(name, data)
{
    if (typeof localStorage === 'undefined') return;

    try {
        localStorage.setItem(name, JSON.stringify(data));
    } catch (error) {
        // Persistence must never prevent a successful admin action from completing.
    }
}
